export const COVER_TEMPLATES = [
  {
    id: 'harvard_professional',
    label: 'Harvard Professional',
    description: 'Traditional, highly structured business letter format with Georgia typography. Best for consulting, finance, and corporate leadership.',
  },
  {
    id: 'modern_professional',
    label: 'Modern Professional',
    description: 'Clean, minimalist sans-serif layout with generous whitespace. Ideal for software engineering, product, and tech roles.',
  },
  {
    id: 'executive_letter',
    label: 'Executive Letter',
    description: 'Dignified serif format highlighting professional leadership, complete with custom signature spacing.',
  },
  {
    id: 'startup_letter',
    label: 'Startup Letter',
    description: 'Warm, conversational, and direct layout. Ideal for YC applicants and early-stage startup opportunities.',
  },
  {
    id: 'creative_letter',
    label: 'Creative Letter',
    description: 'Magazine-inspired format featuring a bold left border highlight and modern editorial structure.',
  },
  {
    id: 'academic_letter',
    label: 'Academic Letter',
    description: 'Times New Roman classical scholarly format optimized for university chairs and department committees.',
  },
  {
    id: 'government_letter',
    label: 'Government Letter',
    description: 'Structured federal USAJOBS format with a gray header block designed for public sector compliance.',
  },
  {
    id: 'sales_letter',
    label: 'Sales Letter',
    description: 'Assertive, achievement-driven layout featuring bold metrics highlights and direct value propositions.',
  },
  {
    id: 'product_manager_letter',
    label: 'Product Manager Letter',
    description: 'Problem-Solution-Impact structured layout prioritizing metrics and tactical product decisions.',
  },
  {
    id: 'finance_letter',
    label: 'Finance Letter',
    description: 'Conservative, high-trust, double-bordered format designed for private equity and investment banking.',
  },
  {
    id: 'internship_letter',
    label: 'Internship Letter',
    description: 'Friendly, fresher-focused layout prioritizing university achievements, projects, and learning agility.',
  },
  {
    id: 'career_change_letter',
    label: 'Career Change Letter',
    description: 'Storytelling-driven format structured to showcase transferable skills and professional motivation.',
  },
];
